import { Button } from "@oc-labs/wt-storybook"
import { UploadIcon, EditIcon, TrashIcon } from "lucide-react"
import { useRef } from "react"

export default function EditableImage({ image = null, className = "", imageClassName = "", onImageChange = () => {}, base64 = true }) {
  const fileInputRef = useRef(null)

  const handleUploadImage = (event) => {
    const file = event.target.files[0]
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader()
      if (!base64) {
        return onImageChange(file) // return the file object directly
      }
      reader.onloadend = () => {
        onImageChange(reader.result) // base64 string (Data URL)
      }
      reader.readAsDataURL(file)
    } else {
      console.error("Please upload a valid image file.")
    }
  }


  return (<div className={`relative items-center justify-center h-[400px] ${className}`}>
    {image ? (
      <div className="relative group">
        <div className="flex items-center justify-center w-full h-full">
          <img
            src={`${image}` || "/placeholder.svg"}
            alt="Uploaded Logo"
            className={`max-w-full object-contain rounded-lg h-[400px] ${imageClassName}`}
          />
        </div>

        {/* Overlay with edit/remove buttons */}
        <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-200 rounded-lg flex items-center justify-center gap-2">
          <div>
            <Button
              type="tertiary"
              size="small"
              onClick={() => fileInputRef.current.click()}
            >
              <EditIcon className="w-4 h-4" />
              Edit
            </Button>
          </div>

          <div>
            <Button
              type="secondary"
              size="small"
              onClick={() => {
                onImageChange(null)
                fileInputRef.current.value = ""
              }}
              className="danger"
            >
              <TrashIcon className="w-4 h-4" />
              Remove
            </Button>
          </div>
        </div>
      </div>
    ) : (
      <label className="flex flex-col items-center justify-center w-full h-full border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-colors">
        <div className="flex flex-col items-center justify-center py-2 min-h-s[300px]">
          <UploadIcon className="w-6 h-6 mb-2 text-gray-500" />
          <p className="text-xs text-gray-500 text-center">Upload</p>
        </div>
        <input type="file" className="hidden" accept="image/*" onChange={handleUploadImage} ref={fileInputRef} />
      </label>
    )}

    {/* Hidden file input for editing */}
    {image && (
      <input type="file" className="hidden" accept="image/*" onChange={handleUploadImage} ref={fileInputRef} />
    )}
  </div>)
}